/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Geographic eligibility rules enforced at the challenge sign-in modal. allowedCountries gates which ISO country codes can participate; hardBlockStates lists U.S. state codes that cannot participate at all (modal refuses to submit, no membership created); softBlockStates lists U.S. state codes that may participate but are not prize-eligible (membership is created with status="prize-restricted", which propagates to ChallengeDraw entry pools and prize-bearing wheel spins). Empty/omitted means no geo gate (non-geo-gated challenges unaffected).
 * @export
 * @interface ChallengeEligibilityGeo
 */
export interface ChallengeEligibilityGeo {
    /**
     * ISO-3166-1 alpha-2 country codes (e.g. ["US"]) the challenge accepts. Empty means no country gate.
     * @type {Array<string>}
     * @memberof ChallengeEligibilityGeo
     */
    allowedCountries?: Array<string>;
    /**
     * U.S. state codes (e.g. ["CO","MD","NE","ND","VA"]) that cannot participate. Modal refuses to submit; no membership is ever created.
     * @type {Array<string>}
     * @memberof ChallengeEligibilityGeo
     */
    hardBlockStates?: Array<string>;
    /**
     * If true, U.S. territories (PR/GU/VI/AS/MP) are blocked alongside hardBlockStates.
     * @type {boolean}
     * @memberof ChallengeEligibilityGeo
     */
    hardBlockTerritories?: boolean;
    /**
     * U.S. state codes (e.g. ["NY","FL"]) that may participate but are not eligible to win prizes. Membership is created with status="prize-restricted".
     * @type {Array<string>}
     * @memberof ChallengeEligibilityGeo
     */
    softBlockStates?: Array<string>;
    /**
     * When true, users from any country are admitted to the challenge for bragging rights — countries outside allowedCountries are admitted with status="prize-restricted" instead of being 403'd at registration. Used so any Realm user can participate in a country-restricted sweepstakes while prizes/Finals stay reserved for eligible residents. When false (default) the hard-block on non-allowed countries still applies.
     * @type {boolean}
     * @memberof ChallengeEligibilityGeo
     */
    admitAllCountries?: boolean;
    /**
     * Optional URL to the Official Rules document. Surfaced as a "Read full rules" link in the eligibility section of the sign-in modal.
     * @type {string}
     * @memberof ChallengeEligibilityGeo
     */
    officialRulesUrl?: string;
}

/**
 * Check if a given object implements the ChallengeEligibilityGeo interface.
 */
export function instanceOfChallengeEligibilityGeo(value: object): value is ChallengeEligibilityGeo {
    return true;
}

export function ChallengeEligibilityGeoFromJSON(json: any): ChallengeEligibilityGeo {
    return ChallengeEligibilityGeoFromJSONTyped(json, false);
}

export function ChallengeEligibilityGeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeEligibilityGeo {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedCountries': json['allowedCountries'] == null ? undefined : json['allowedCountries'],
        'hardBlockStates': json['hardBlockStates'] == null ? undefined : json['hardBlockStates'],
        'hardBlockTerritories': json['hardBlockTerritories'] == null ? undefined : json['hardBlockTerritories'],
        'softBlockStates': json['softBlockStates'] == null ? undefined : json['softBlockStates'],
        'admitAllCountries': json['admitAllCountries'] == null ? undefined : json['admitAllCountries'],
        'officialRulesUrl': json['officialRulesUrl'] == null ? undefined : json['officialRulesUrl'],
    };
}

export function ChallengeEligibilityGeoToJSON(json: any): ChallengeEligibilityGeo {
    return ChallengeEligibilityGeoToJSONTyped(json, false);
}

export function ChallengeEligibilityGeoToJSONTyped(value?: ChallengeEligibilityGeo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedCountries': value['allowedCountries'],
        'hardBlockStates': value['hardBlockStates'],
        'hardBlockTerritories': value['hardBlockTerritories'],
        'softBlockStates': value['softBlockStates'],
        'admitAllCountries': value['admitAllCountries'],
        'officialRulesUrl': value['officialRulesUrl'],
    };
}

